const darkColors = [
  "#BF4040",
  "#4060BF",
  "#4040BF",
  "#6040BF",

  "#8040BF",
  "#9F40BF",
  "#BF409F",
  "#BF4080"
];
const lightColors = [
  "#FF6666",
  "#BF6040",
  "#CC99FF",
  "#EFEFEF",
  "#FEE1E1",
  "#FF9999",
  "#FEE9E1",
  "#FFB299",
  "#FF8C66",
  "#FEF7E1",
  "#FFE599",
  "#FFD966",
  "#D6B85C",
  "#FEFEE1",
  "#FFFF99",
  "#FFFF33",
  "#BFBF40",
  "#F7FEE1",
  "#E5FF99",
  "#9FBF40",
  "#F0FEE1",
  "#CCFF99",
  "#80BF40",
  "#E9FEE1",
  "#B3FF99",
  "#60BF40",
  "#E1FEE1",
  "#99FF99",
  "#40BF40",
  "#E1FEE9",
  "#99FFB3",
  "#40BF60",
  "#E1FEF0",
  "#99FFCC",
  "#40BF80",
  "#E1FEF7",
  "#99FFE5",
  "#40BF9F",
  "#E1FEFE",
  "#99FFFF",
  "#40BFBF",
  "#E1F7FE",
  "#99E5FF",
  "#409FBF",
  "#E1F0FE",
  "#99CCFF",
  "#4080BF",
  "#E1E9FE",
  "#99B3FF",
  "#E1E1FE",
  "#9999FF",
  "#E9E1FE",
  "#B399FF",
  "#F0E1FE",
  "#F7E1FE",
  "#E599FF",
  "#FEE1FE",
  "#FF99FF",
  "#BF40BF",
  "#FEE1F7",
  "#FF99E5",
  "#FEE1F0",
  "#FF99CC"
];

const colors = [
  "#EFEFEF",
  "#FEE1E1",
  "#FF9999",
  "#FF6666",
  "#BF4040",
  "#FEE9E1",
  "#FFB299",
  "#FF8C66",
  "#BF6040",
  "#FEF7E1",
  "#FFE599",
  "#FFD966",
  "#D6B85C",
  "#FEFEE1",
  "#FFFF99",
  "#FFFF33",
  "#BFBF40",
  "#F7FEE1",
  "#E5FF99",
  "#9FBF40",
  "#F0FEE1",
  "#CCFF99",
  "#80BF40",
  "#E9FEE1",
  "#B3FF99",
  "#60BF40",
  "#E1FEE1",
  "#99FF99",
  "#40BF40",
  "#E1FEE9",
  "#99FFB3",
  "#40BF60",
  "#E1FEF0",
  "#99FFCC",
  "#40BF80",
  "#E1FEF7",
  "#99FFE5",
  "#40BF9F",
  "#E1FEFE",
  "#99FFFF",
  "#40BFBF",
  "#E1F7FE",
  "#99E5FF",
  "#409FBF",
  "#E1F0FE",
  "#99CCFF",
  "#4080BF",
  "#E1E9FE",
  "#99B3FF",
  "#4060BF",
  "#E1E1FE",
  "#9999FF",
  "#4040BF",
  "#E9E1FE",
  "#B399FF",
  "#6040BF",
  "#F0E1FE",
  "#CC99FF",
  "#8040BF",
  "#F7E1FE",
  "#E599FF",
  "#9F40BF",
  "#FEE1FE",
  "#FF99FF",
  "#BF40BF",
  "#FEE1F7",
  "#FF99E5",
  "#BF409F",
  "#FEE1F0",
  "#FF99CC",
  "#BF4080"
];

export { darkColors, lightColors, colors };
